/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_StaffWorkloadResponse_ } from '../models/PaginatedResponse_StaffWorkloadResponse_';
import type { StaffWorkloadDetailResponse } from '../models/StaffWorkloadDetailResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HistoryStaffWorkloadService {
    /**
     * List Staff Workload
     * 직원 업무 보유 현황 목록 (데이터센터)
     *
     * 워크스페이스 소속 활성 기관 멤버 1명당 1행. 이름 가나다순, DB 페이지네이션.
     * 기관 owner/admin 만 조회 가능 (403).
     *
     * 집계 기준:
     * - 세부실행과제/수행업무: 그 멤버가 담당자(Task.assignee)인 활성 과제·그 과제의 활성 수행업무
     * - 사업/전략과제/실행과제: 담당 세부실행과제를 하나라도 포함하는 상위의 distinct 수
     * - 변경이력 횟수: 이 워크스페이스에서 그 멤버가 남긴 감사 로그 수 (행위자 기준)
     * - 날짜 연기 횟수/변경일 합계: 수행업무 종료일(end_at)을 뒤로 미룬 수정 횟수와 밀린 일수 합
     *
     * Args:
     * org_id: 기관 ID (필수)
     * workspace_id: 워크스페이스 ID (필수)
     * q: 검색 키워드 (선택) — 사용자명, 이메일
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * @returns PaginatedResponse_StaffWorkloadResponse_ OK
     * @throws ApiError
     */
    public static appsHistoryViewsListStaffWorkload({
        orgId,
        workspaceId,
        q,
        page = 1,
        perPage = 100,
    }: {
        orgId: string,
        workspaceId: string,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_StaffWorkloadResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/history/staff-workload',
            query: {
                'org_id': orgId,
                'workspace_id': workspaceId,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Staff Workload Detail
     * 직원 업무 보유 현황 상세 (데이터센터 사이드패널)
     *
     * 목록 행과 같은 요약 수치에 더해
     * - tasks: 담당 세부실행과제의 (실행과제 연결 × 수행업무) 조합마다 1행. 연결/수행업무가 없으면 해당 이름은 null
     * - postponements: 수행업무 종료일을 뒤로 미룬 수정 이력(최신순) + delay_days
     *
     * 변경이력 탭은 GET /history/action?account_id=<account_id>&workspace_id= 로 조회한다.
     * 기관 owner/admin 만 (403). 멤버가 없거나 워크스페이스 미소속이면 404.
     * @returns StaffWorkloadDetailResponse OK
     * @throws ApiError
     */
    public static appsHistoryViewsGetStaffWorkloadDetail({
        memberId,
        orgId,
        workspaceId,
    }: {
        memberId: string,
        orgId: string,
        workspaceId: string,
    }): CancelablePromise<StaffWorkloadDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/history/staff-workload/{member_id}',
            path: {
                'member_id': memberId,
            },
            query: {
                'org_id': orgId,
                'workspace_id': workspaceId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
